import { VisibilityStatus } from "@evidenceb/gameplay-interfaces";
import type { MinimalData } from "../interfaces/Data";

type WithVisibility = { visibilityStatus: VisibilityStatus };

/** Disabled items are kept in data so history can resolve them. */
export const isKeptInData = ({ visibilityStatus }: WithVisibility): boolean =>
  visibilityStatus === VisibilityStatus.Visible ||
  visibilityStatus === VisibilityStatus.Unavailable ||
  visibilityStatus === VisibilityStatus.Disabled;

export const isLocked = ({ visibilityStatus }: WithVisibility): boolean =>
  visibilityStatus === VisibilityStatus.Unavailable ||
  visibilityStatus === VisibilityStatus.Disabled;

export const isDisplayed = ({ visibilityStatus }: WithVisibility): boolean =>
  visibilityStatus !== VisibilityStatus.Disabled;

/** Ids are compared rather than looked up, as dashboards may list ids absent from data. */
export const hiddenIds = (
  items: (WithVisibility & { id: string })[],
): Set<string> =>
  new Set(items.filter((item) => !isDisplayed(item)).map(({ id }) => id));

export const withoutHiddenActivities = <T extends { activityIds: string[] }>(
  objective: T,
  data: Pick<MinimalData, "activities">,
): T => {
  const hiddenActivityIds = hiddenIds(data.activities);
  return {
    ...objective,
    activityIds: objective.activityIds.filter(
      (activityId) => !hiddenActivityIds.has(activityId),
    ),
  };
};
